/**
 * Go back in history or to the given route
 *
 * @param  {Object} history
 * @param  {String} route
 */
export function goBack(history, route) {
  return history.length > 2 ? history.goBack() : history.push(route);
}
